<template>
  <div :style="{ direction: directionStyle }">
    <!-- email -->
    <div class="content">
      <img
        class="email_fanhui"
        :class="{ fanzhuan: directionStyle == 'rtl' }"
        src="static/img/cz_web_return.png"
        @click="goback()"
      />
      <div class="email_content">
        <div><img class="email_img" src="static/img/cz_web_mail.png" /></div>
        <p class="email_contact">{{ $t("m.contact_email") }}</p>
        <p class="email_desc">{{ $t("m.provide_email") }}</p>

        <p class="email_form_title">{{ $t("m.email_address") }}</p>
        <input
          type="text"
          v-model="emailVal"
          :placeholder="$t('m.email_place_holder')"
          class="email_form_input"
        />

        <!-- <div v-if="payTypeName == 'TapPay'">
          <p class="email_form_title"> first Name </p>
          <input
            type="text"
            v-model="firstName"
            placeholder=""
            class="email_form_input"
          />
          <p class="email_form_title"> last Name </p>
          <input
            type="text"
            v-model="lastName"
            placeholder=" "
            class="email_form_input"
          />
        </div> -->

        <div
          class="email_form_btn"
          :class="{ active: emailIsTrue }"
          @click="submitEmail()"
        >
          {{ $t("m.submit") }}
        </div>
      </div>
      <p class="fc-notice" v-html="$t('m.buy-notice-a')"></p>
    </div>
    <!-- email end -->
    <p class="fc-notice ask">
      <img src="static/img/question_icon.png" class="fc-icon-sm" />
      <a href="#/asks" class="fc-color-gray">{{ $t("m.rechargeFAQ_title") }}</a>
    </p>
  </div>
</template>

<script>
var _self;
import Vue from "vue";
import { Toast } from "vant";
import { getUrlInfo } from '../tools/utils'

Vue.use(Toast);
export default {
  data() {
    return {
      // TODO 打包前记得改
      // apiUrl: "http://tdtesth5.vvvps.com/faceshow", //测试
      apiUrl: "https://checkout.vvvps.com/faceshow", //正式
      directionStyle: "ltr",
      emailVal: "",
      firstName: "",
      lastName: "",
      payTypeName: "",
      emailIsTrue: false,
      selPayStyleId: "",
      selPayStyleNormId: "",
      countryCode: "",
      userInfo: "",
      userId: "",
      token: "",
      pwaFlag: false,  // 是否从pwa跳转过来
    };
  },
  watch: {
    emailVal(val) {
      console.log(val);
      var reg = new RegExp(
        "^[a-z0-9A-Z]+[- | a-z0-9A-Z . _]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\\.)+[a-z]{2,}$"
      );
      if (!reg.test(val)) {
        //Toast();
        this.emailIsTrue = false;
      } else {
        this.emailIsTrue = true;
      }
    },
  },
  filters: {},
  mounted() {
    _self = this;
    _self.userId = _self.$route.params.userId;
    _self.selPayStyleId = _self.$route.params.selPayStyleId;
    _self.selPayStyleNormId = _self.$route.params.selPayStyleNormId;
    _self.countryCode = _self.$route.params.countryCode;
    _self.payTypeName = _self.$route.params.payTypeName;
    _self.firstName = _self.$route.params.nickName;
    _self.pwaFlag = _self.$route.params.pwaFlag;
    if (!_self.selPayStyleId || !_self.selPayStyleNormId) {
      _self.$router.replace({
        path: "/",
      });
    }
    // _self.textSize();
    //_self.getUserInfo();
    _self.getLang();
  },
  methods: {
    //字体大小
    textSize() {
      !(function (a) {
        function b() {
          var b = g.getBoundingClientRect().width;
          (a.rem =
            b / 7.5 > 100 ? 100 : b / 7.5 < 300 / 7.5 ? 300 / 7.5 : b / 7.5),
            (g.style.fontSize = a.rem + "px");
          //a.rem = (b / 7.5), g.style.fontSize = a.rem + "px"
        }
        var g = a.document.documentElement,
          e;
        a.addEventListener(
          "resize",
          function () {
            clearTimeout(e), (e = setTimeout(b, 300));
          },
          !1
        ),
          a.addEventListener(
            "pageshow",
            function (a) {
              a.persisted && (clearTimeout(e), (e = setTimeout(b, 300)));
            },
            !1
          ),
          b();
      })(window);
    },
    getLang() {
      var box = document.getElementById("app");
      let language = navigator.language || navigator.browserLanguage;
      if (language == "ar") {
        box.style.direction = "rtl";
        this.directionStyle = "rtl";
      } else {
        box.style.direction = "ltr";
        this.directionStyle = "ltr";
      }
    },
    goback() {
      window.history.go(-1);
    },
    //缓存读取用户信息
    getUserInfo() {
      return false;
      let userInfo = localStorage.getItem("userInfo");
      //console.log(JSON.stringify(userInfo));
      if (userInfo) {
        let a = JSON.parse(userInfo);
        _self.userInfo = a;
        _self.token = a.token;
      } else {
        _self.exitLogin();
      }
    },
    //提价邮箱
    submitEmail() {
      if (_self.emailIsTrue) {
        _self.createOrderPay(
          _self.selPayStyleId,
          _self.selPayStyleNormId,
          _self.emailVal
        );
      } else {
        console.log("email error");
      }
    },

    createOrderPay(payPlatformId, rechargeId, email) {
      if (payPlatformId == 2) {
        localStorage.setItem("IsWeChatPay", "true");
      } else {
        localStorage.setItem("IsWeChatPay", "false");
      }
      var param = {
        //"systoken": _self.token,
        userId: _self.userId,
        rechargeId: rechargeId,
        countryCode: _self.countryCode,
        email: email || "",
      };
       // 如果是从pwa页面跳转过来的，则需要添加这个参数，充值成功后返回到pwa的水晶兑换页面
      if(_self.pwaFlag || _self.pwaFlag == 'true'){
        const { callbackUrl, fromGame, activeTabIndex } = getUrlInfo();
        param.callbackUrl= decodeURIComponent(`${callbackUrl}?fromGame=${fromGame}&activeTabIndex=${activeTabIndex}`)
      }
      console.log(JSON.stringify(param));
      //return false;
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        icon: "static/img/loading.gif",
        className: "loading",
      });

      if( _self.payTypeName == "TapPayments"){
        param = {
          customer: {
            first_name: this.firstName,
            email: email,
          },
          userId: _self.userId,
          rechargeId: rechargeId,
          countryCode: _self.countryCode,
          email: email || "",
        };
        _self.toTapPay(param)
        return
      }
      // this.$axios({
      //   method: "post",
      //   url: "/web/h5/pay/createOrder",
      //   params: {
      //     param: JSON.stringify(param),
      //   },
      // })
      this.$axios.post(
        '/web/h5/pay/createOrder',
        param
      )
        .then((res) => {
          Toast.clear();
          if (res.data.code == 1) {
            var tradeNo = res.data.result.tradeNo;
            //跳转第三方
            // if (payPlatformId == 3) {
            //   //3 代表paypal
            //   window.location.href = _self.paypalUrl + "/web/h5/pay/start?tradeNo=" + tradeNo;
            // } else {
            window.location.href =
              _self.apiUrl + "/web/h5/pay/start?tradeNo=" + tradeNo;
            // }
          } else if (res.data.code == 6000) {
            Dialog.alert({
              message: "Transaction failed: system abnormal",
              confirmButtonText: "OK",
            }).then(() => {
              // on close
            });
          } else if (res.data.code == 0) {
            //_self.exitLogin();
          }
        })
        .catch((error) => {
          console.log(error); //  错误处理 相当于error
          Toast("getPayChannels Ajax error!");
        });
    },
    toTapPay(param){
       this.$axios.post(
        // '/web/h5/pay/createOrder',
        _self.apiUrl + '/api/tap/createOrder',
        param
      )
        .then((res) => {
          Toast.clear();
          if (res.data.code == 1) {
            var tradeNo = res.data.tradeNo;
            //跳转第三方
            // if (payPlatformId == 3) {
            //   //3 代表paypal
            //   window.location.href = _self.paypalUrl + "/web/h5/pay/start?tradeNo=" + tradeNo;
            // } else {
            window.location.href =
              _self.apiUrl + "/api/tap/redirect?tradeNo=" + tradeNo;
            // }
          } else if (res.data.code == 6000) {
            Dialog.alert({
              message: "Transaction failed: system abnormal",
              confirmButtonText: "OK",
            }).then(() => {
              // on close
            });
          } else if (res.data.code == 0) {
            //_self.exitLogin();
          }
        })
        .catch((error) => {
          console.log(error); //  错误处理 相当于error
          Toast("getPayChannels Ajax error!");
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/email.vue